import React, { Component } from "react";
import {
	Panel,
	Row,
	Col,
	ControlLabel,
	Button,
	Table,
	Radio
} from "react-bootstrap";
import "react-select/dist/react-select.css";
import Pagination from "react-js-pagination";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import AsyncPaginate from "react-select-async-paginate";
import style from "./style.css";

export default class EVoucherChecker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			memberDetail: null,
			selectedCampaignCategory: null,

			campaignCategory_isLoading: false,
			campaignCategory_data: [],
			campaignCategory_count: 0,
			campaignCategory_page: 1,
			campaignCategory_limit: 10,

			evoucherRedemptionLog_isLoading: false,
			evoucherRedemptionLog_data: [],
			evoucherRedemptionLog_count: 0,
			evoucherRedemptionLog_page: 1,
			evoucherRedemptionLog_limit: 10,
		};

		this.getCampaignCategoryList = this.getCampaignCategoryList.bind(this);
		this.getEVoucherList = this.getEVoucherList.bind(this);
	}

	async memberOptions(input, loadedOptions) {
		let query, objItem;

		query = new Parse.Query("MemberDetail");

		query
			.exists("memberId")
			.notEqualTo("memberId", "")
			.exists("cardType")
			.notEqualTo("cardType", "");

		if (input.trim() !== "") {
			query.matches("memberId", input, "i");
		}
		objItem = (item) => {
			return {
				label: item.get("memberId"),
				value: item,
			};
		};

		query.limit(10);
		query.ascending("memberId");

		if (loadedOptions.length !== 0) {
			query.skip(loadedOptions.length);
		}

		return query
			.find()
			.then((data) => {
				return data.map(objItem);
			})
			.then((data) => {
				return { options: data, hasMore: data.length === 10 };
			})
			.catch((err) => {
				console.log("loadOptions error");
				console.log(err);

				return { options: [], hasMore: false };
			});
	}

	async getCampaignCategoryList(page = 1) {
		const {
			memberDetail,

			campaignCategory_limit,
		} = this.state;

		if (!memberDetail) {
			return toast.error("Member ID is required.");
		}

		this.setState({
			selectedCampaignCategory: null,

			campaignCategory_isLoading: true,
			campaignCategory_page: page,
		});

		try {
			const { data, count } = await Parse.Cloud.run("getCampaignList", {
				memberId: memberDetail.value.get("memberId"),
				cardType: memberDetail.value.get("cardType"),
				page,
				limit: campaignCategory_limit,

				gender: memberDetail.value.get("gender") || "",
				dateAdded: memberDetail.value.get("dateAdded") || "",
				dateOfBirth: memberDetail.value.get("dateOfBirth") || "",
			});

			this.setState({
				campaignCategory_isLoading: false,
				campaignCategory_data: data,
				campaignCategory_count: count,
			});
		} catch (error) {
			this.setState({
				campaignCategory_isLoading: false,
			});

			const errorMessage = error.message;

			toast.error(errorMessage);
		}
	}

	async getEVoucherList(page = 1) {
		const {
			memberDetail,
			selectedCampaignCategory,

			evoucherRedemptionLog_limit,
		} = this.state;

		this.setState({
			evoucherRedemptionLog_isLoading: true,
			evoucherRedemptionLog_page: page,
		});

		try {
			const { data, count } = await Parse.Cloud.run("getCampaignEVoucherList", {
				campaignCategoryId: selectedCampaignCategory.id,
				memberId: memberDetail.value.get("memberId"),
				cardType: memberDetail.value.get("cardType"),
				page,
				limit: evoucherRedemptionLog_limit,

				gender: memberDetail.value.get("gender") || "",
				dateAdded: memberDetail.value.get("dateAdded") || "",
				dateOfBirth: memberDetail.value.get("dateOfBirth") || "",
			});

			this.setState({
				evoucherRedemptionLog_isLoading: false,
				evoucherRedemptionLog_data: data,
				evoucherRedemptionLog_count: count,
			});
		} catch (error) {
			this.setState({
				evoucherRedemptionLog_isLoading: false,
			});

			const errorMessage = error.message;

			toast.error(errorMessage);
		}
	}

	render() {
		const {
			memberDetail,
			selectedCampaignCategory,

			campaignCategory_isLoading,
			campaignCategory_data,
			campaignCategory_count,
			campaignCategory_page,
			campaignCategory_limit,

			evoucherRedemptionLog_isLoading,
			evoucherRedemptionLog_data,
			evoucherRedemptionLog_count,
			evoucherRedemptionLog_page,
			evoucherRedemptionLog_limit,
		} = this.state;

		const space = {
			paddingTop: "10px",
			paddingBottom: "10px",
		};

		let requiredSpan = <span style={{ color: "red" }}>*</span>;

		console.log("test", {
			campaignCategory_isLoading,
			campaignCategory_data,
			campaignCategory_count,
			campaignCategory_page,
			campaignCategory_limit,

			evoucherRedemptionLog_isLoading,
			evoucherRedemptionLog_data,
			evoucherRedemptionLog_count,
			evoucherRedemptionLog_page,
			evoucherRedemptionLog_limit,
		});
		return (
			<div>
				<Panel>
					<Panel.Heading
						style={{
							backgroundColor: "#D1282F",
							color: "white",
						}}
					>
						<h4>Member EV Checker</h4>
					</Panel.Heading>
					<Panel.Body>
						<Row>
							<Col md={6} mdOffset={3}>
								<Row style={space}>
									<Col md={4}>
										<ControlLabel>Member ID</ControlLabel>
									</Col>
									<Col md={8}>
										<AsyncPaginate
											multi={false}
											placeholder="Select or Search..."
											value={memberDetail}
											onChange={(value) => {
												this.setState({
													memberDetail: value,
													campaignCategory_data: [],
													campaignCategory_count: 0,
													campaignCategory_page: 1,
													campaignCategory_limit: 10,

													evoucherRedemptionLog_data: [],
													evoucherRedemptionLog_count: 0,
													evoucherRedemptionLog_page: 1,
													evoucherRedemptionLog_limit: 10,
												});
											}}
											loadOptions={this.memberOptions}
										/>
									</Col>
								</Row>
							</Col>
						</Row>
						{memberDetail && [
							<br />,
							<Row>
								<Col md={6} mdOffset={3}>
									<Table striped bordered condensed hover style={{ margin: 0 }}>
										<tbody>
											{[
												{
													label: "Member ID",
													value: memberDetail.value.get("memberId") || "",
												},
												{
													label: "Card Type",
													value: memberDetail.value.get("cardType") || "",
												},
											].map((item, key) => (
												<tr>
													<td>
														<b>{item.label}</b>
													</td>
													<td>{item.value}</td>
												</tr>
											))}
										</tbody>
									</Table>
								</Col>
							</Row>,
						]}
						<br />
						<Row>
							<Col md={12} style={{ textAlign: "center" }}>
								<Button
									bsStyle="primary"
									disabled={campaignCategory_isLoading}
									onClick={() => this.getCampaignCategoryList()}
								>
									SUBMIT
								</Button>
							</Col>
						</Row>
						<br />
						<br />
						<Row>
							<Col md={12}>
								<ControlLabel>Campaign Category List</ControlLabel>
								<Table
									className={style.table}
									striped
									bordered
									condensed
									hover
									style={{ margin: 0 }}
									responsive
								>
									<thead>
										<tr>
											<th>Select</th>
											{[
												"Image",
												"Title",
												"Campaign Start Date",
												"Campaign End Date",
											].map((columnName, index) => (
												<th key={index}>{columnName}</th>
											))}
										</tr>
									</thead>
									<tbody>
										{campaignCategory_isLoading && (
											<tr>
												<td
													colSpan={15}
													style={{
														textAlign: "center",
														color: "#808080",
													}}
												>
													<i className="fa fa-spinner fa-spin fa-3x"></i>
												</td>
											</tr>
										)}
										{!campaignCategory_isLoading &&
											campaignCategory_data.length === 0 && (
												<tr>
													<td
														colSpan={15}
														style={{
															textAlign: "center",
															color: "#808080",
														}}
													>
														No Data Available
													</td>
												</tr>
											)}
										{!campaignCategory_isLoading &&
											campaignCategory_data.map((item, index) => {
												const { campaignCategory } = item;

												return (
													<tr key={index}>
														<td
															style={{
																verticalAlign: "middle",
																textAlign: "center",
															}}
														>
															<Radio
																className={style.radio}
																checked={
																	selectedCampaignCategory &&
																	selectedCampaignCategory.id ===
																		campaignCategory.id
																}
																onChange={(e) => {
																	this.setState(
																		{
																			selectedCampaignCategory:
																				campaignCategory,

																			evoucherRedemptionLog_data: [],
																			evoucherRedemptionLog_count: 0,
																			evoucherRedemptionLog_page: 1,
																		},
																		() => {
																			this.getEVoucherList();
																		}
																	);
																}}
															/>
														</td>
														{[
															campaignCategory.get("image") ? (
																<div
																	style={{
																		maxWidth: "200px",
																		maxHeight: "200px",
																		height: "200px",
																		width: "200px",
																		display: "table-cell",
																		verticalAlign: "middle",
																		minWidth: "200px",
																	}}
																>
																	<img
																		style={{ width: "100%" }}
																		src={campaignCategory.get("image").url()}
																	/>
																</div>
															) : (
																""
															),
															campaignCategory.get("title") || "",
															(campaignCategory.get("campaignStartDate") &&
																moment(
																	campaignCategory.get("campaignStartDate")
																).format("MM/DD/YYYY hh:mm:ss A")) ||
																"",
															(campaignCategory.get("campaignEndDate") &&
																moment(
																	campaignCategory.get("campaignEndDate")
																).format("MM/DD/YYYY hh:mm:ss A")) ||
																"",
														].map((value, index) => (
															<td key={index}>{value}</td>
														))}
													</tr>
												);
											})}
									</tbody>
								</Table>
								<div style={{ float: "left", marginTop: "10px" }}>
									Total Records: {campaignCategory_count}
								</div>
								<div style={{ float: "right" }}>
									<Pagination
										{...{
											activePage: campaignCategory_page,
											itemsCountPerPage: campaignCategory_limit,
											totalItemsCount: campaignCategory_count,
											pageRangeDisplayed: 5,
											onChange: (page) => {
												if (campaignCategory_page !== page) {
													this.getCampaignCategoryList(page);
												}
											},
										}}
									/>
								</div>
							</Col>
						</Row>
						<Row>
							<Col md={12}>
								<ControlLabel>EVoucher List</ControlLabel>
								<Table
									className={style.table}
									striped
									bordered
									condensed
									hover
									style={{ margin: 0 }}
									responsive
								>
									<thead>
										<tr>
											{[
												"Image",
												"EVoucher",
												"Status",
												"Date Claimed",
												"Expiration",
												"Earned Points",
												"Voucher No",
												"Transaction ID",
											].map((columnName, index) => (
												<th key={index}>{columnName}</th>
											))}
										</tr>
									</thead>
									<tbody>
										{evoucherRedemptionLog_isLoading && (
											<tr>
												<td
													colSpan={15}
													style={{
														textAlign: "center",
														color: "#808080",
													}}
												>
													<i className="fa fa-spinner fa-spin fa-3x"></i>
												</td>
											</tr>
										)}
										{!evoucherRedemptionLog_isLoading &&
											evoucherRedemptionLog_data.length === 0 && (
												<tr>
													<td
														colSpan={15}
														style={{
															textAlign: "center",
															color: "#808080",
														}}
													>
														No Data Available
													</td>
												</tr>
											)}
										{!evoucherRedemptionLog_isLoading &&
											evoucherRedemptionLog_data.map((item, index) => {
												const { evoucherRedemptionLog } = item;
												const evoucher = evoucherRedemptionLog.get("EVoucher");

												let pointTypeShortName, requiredEarningAmount;

												if (
													evoucher &&
													evoucher &&
													evoucher.get("pointType") &&
													evoucher.get("pointType").get("shortName") &&
													(evoucher.get("requiredEarningAmount") || 0) > 0
												) {
													pointTypeShortName = evoucher
														.get("pointType")
														.get("shortName");

													requiredEarningAmount = evoucher.get(
														"requiredEarningAmount"
													);
												}

												return (
													<tr key={index}>
														{[
															evoucher && evoucher.get("image") ? (
																<div
																	style={{
																		maxWidth: "200px",
																		maxHeight: "200px",
																		height: "200px",
																		width: "200px",
																		display: "table-cell",
																		verticalAlign: "middle",
																		minWidth: "200px",
																	}}
																>
																	<img
																		style={{ width: "100%" }}
																		src={evoucher.get("image").url()}
																	/>
																</div>
															) : (
																""
															),
															[
																<ControlLabel>Title:</ControlLabel>,
																<br />,
																(evoucher && evoucher.get("title")) || "",
																<br />,
																<br />,
																<ControlLabel>
																	Campaign Start Date:
																</ControlLabel>,
																<br />,
																(evoucher &&
																	evoucher.get("campaignStartDate") &&
																	moment(
																		evoucher.get("campaignStartDate")
																	).format("MM/DD/YYYY hh:mm:ss A")) ||
																	"",
																<br />,
																<br />,
																<ControlLabel>Campaign End Date:</ControlLabel>,
																<br />,
																(evoucher &&
																	evoucher.get("campaignEndDate") &&
																	moment(
																		evoucher.get("campaignEndDate")
																	).format("MM/DD/YYYY hh:mm:ss A")) ||
																	"",
																pointTypeShortName &&
																	requiredEarningAmount && [
																		<br />,
																		<br />,
																		<ControlLabel>
																			Required Earning Amount:
																		</ControlLabel>,
																		<br />,
																		`${
																			requiredEarningAmount || 0
																		} ${pointTypeShortName}`,
																	],
															],
															evoucherRedemptionLog.get("status") || "",
															(evoucherRedemptionLog.get("dateClaimed") &&
																moment(
																	evoucherRedemptionLog.get("dateClaimed")
																).format("MM/DD/YYYY hh:mm:ss A")) ||
																"",
															(evoucherRedemptionLog.get("voucherExpiration") &&
																moment(
																	evoucherRedemptionLog.get("voucherExpiration")
																).format("MM/DD/YYYY hh:mm:ss A")) ||
																"",
															(pointTypeShortName &&
																`${
																	evoucherRedemptionLog.get(
																		pointTypeShortName
																	) || 0
																} ${pointTypeShortName}`) ||
																"",
															evoucherRedemptionLog.get("voucherNumber") || "",
															evoucherRedemptionLog.get("transactionId") || "",
														].map((value, index) => (
															<td key={index}>{value}</td>
														))}
													</tr>
												);
											})}
									</tbody>
								</Table>
								<div style={{ float: "left", marginTop: "10px" }}>
									Total Records: {evoucherRedemptionLog_count}
								</div>
								<div style={{ float: "right" }}>
									<Pagination
										{...{
											activePage: evoucherRedemptionLog_page,
											itemsCountPerPage: evoucherRedemptionLog_limit,
											totalItemsCount: evoucherRedemptionLog_count,
											pageRangeDisplayed: 5,
											onChange: (page) => {
												if (evoucherRedemptionLog_page !== page) {
													this.getEVoucherList(page);
												}
											},
										}}
									/>
								</div>
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<ToastContainer />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/MemberEVChecker/index.js